module.exports = __webpack_public_path__ + "img/mx_01.54004c81.jpg";